import { apiFetch } from '../utils/api';

export interface LoginResponse {
  accessToken: string;
  tokenType: string;
  expiresIn: string;
  user: UserProfile;
  role?: string | null;
}

export interface UserProfile {
  id: string;
  username: string;
  erpId: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  mobileNumber?: string | null;
  typeKey?: string | null;
  locations?: Array<{
    id: number;
    name: string;
    businessHoursStart?: string | null;
    businessHoursEnd?: string | null;
  }>; // empty array => all locations
  createdAt?: string;
  updatedAt?: string;
}

export interface RoundOffConfigurationItem {
  decimalPlace: string;
  value: string;
}

export interface CompanyCurrency {
  currencyId: number;
  symbol: string;
  rate: string;
}

export interface CompanyConfig {
  id: string;
  companyName: string | null;
  companyCode: string | null;
  erpCompanyId: number | null;
  lightLogo: string | null;
  darkLogo: string | null;
  currencySymbol: string | null;
  defaultCurrency: CompanyCurrency | null;
  currencies: CompanyCurrency[];
  roundOffConfiguration: RoundOffConfigurationItem[];
  companyEmail: string | null;
  companyWebsite: string | null;
  companyLegalName: string | null;
  grnFormat: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface MeResponse {
  user: UserProfile;
  companyConfig: CompanyConfig | null;
  role?: string | null;
}

export interface LoginDto {
  username: string;
  password: string;
}

export const login = (dto: LoginDto) =>
  apiFetch<LoginResponse>('/users/login', {
    method: 'POST',
    body: JSON.stringify(dto),
    skipAuth: true,
  });

export const fetchCurrentUser = () => apiFetch<MeResponse>('/users/me');
